export const SELECTION_TOOLBAR_LABEL = 'Selection toolbar';
